import { URL } from '../../../config'
import { getRequest } from '../../../utils/functions/httpRequest'

export const getActiveSeasons = function () 
{
  const activeEndpoint = `/active`
  const seasonURL =  `${URL.season}${activeEndpoint}` 
  return getRequest(seasonURL)
}



// WEBPACK FOOTER //
// ./src/components/common/api/getActiveSeasons.js